"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var stickyButton = document.querySelector('a.main.hero-button');
stickyButton.addEventListener('mousemove', function (e) {
    var pos = stickyButton.getBoundingClientRect();
    var mx = e.clientX - pos.left - pos.width / 2;
    var my = e.clientY - pos.top - pos.height / 2;
    stickyButton.style.transform = "\n        translate(".concat(mx * 0.15, "px ,").concat(my * 0.3, "px)\n        rotate3d(").concat(mx * -0.1, ", ").concat(my * -0.3, ", 0, 12deg)\n    ");
});
stickyButton.addEventListener('mouseenter', function (e) {
    stickyButton.style.transition = '';
});
stickyButton.addEventListener('mouseleave', function (e) {
    // stickyButton.className = 'hero-btn main'
    stickyButton.style.transform = '';
    stickyButton.style.transition = '0.2s ease';
});
var htmlWord = document.querySelector('span.typer-word');
var words = ['اداری', 'خانگی', 'استادیومی', 'رستورانی', 'ویلایی', 'آموزشی'];
var currentMessage = 0;
var DELETE_DELAY = 1000;
var START_DELAY = 250;
function typeMessage() {
    if (!words[currentMessage]) {
        currentMessage = 0;
    }
    var currentStr = words[currentMessage];
    currentStr.split('');
    var part = '';
    var currentLetter = 0;
    var int1 = setInterval(function () {
        if (!currentStr[currentLetter]) {
            currentMessage++;
            setTimeout(function () {
                deleteMessage(part);
            }, DELETE_DELAY);
            clearInterval(int1);
        }
        else {
            part += currentStr[currentLetter++];
            htmlWord.innerText = part;
        }
    }, 100);
}
function deleteMessage(str) {
    var int = setInterval(function () {
        if (str.length === 0) {
            setTimeout(function () {
                typeMessage();
            }, START_DELAY);
            clearInterval(int);
        }
        else {
            str = str.split('');
            str.pop();
            str = str.join('');
            htmlWord.innerHTML = str;
        }
    }, 50);
}
typeMessage();
